import { render, staticRenderFns } from "./documentsDashboard.vue?vue&type=template&id=1e7f6092"
import script from "./documentsDashboard.vue?vue&type=script&lang=js"
export * from "./documentsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports